import { supabase } from '@/utils/supabase/client';
import { Profile as ProfileType } from '@/types/supabase';

export const updateProfile = async (userId: string, data: Partial<ProfileType>) => {
  try {
    // Use safe RPC for update (service role, no RLS)
    const { error } = await supabase.rpc('update_profile_safe', {
      p_user_id: userId,
      p_updates: data
    });
    if (error) throw error;
  } catch (error: any) {
    console.error('Update profile error in auth-utils:', error);
    throw new Error(`Failed to update profile: ${error.message}`);
  }
};